/**
 * Using floor() instead of round() because:
 *
 * - For genomic data, you typically want positions to align consistently to the left.
 * - When drawing features with widths, using floor ensures consistent spacing and prevents pixel rounding errors from accumulating.
 */

/**
 * Usually used for start position
 * !Only use when a Canvas shape has a stroke. Stroke are drawn in the middle.
 * !So a 1px stroke, is 2 half of a pixels if we don't move by .5px. And it's blurry.
 */
export function alignToLeftPixelGrid(value: number): number {
  return Math.floor(value) + 0.5;
}

/**
 * Usually used for stop position.
 */
export function alignToRightPixelGrid(value: number): number {
  return Math.floor(value) + 0.5;
}
